import { render, staticRenderFns } from "./fund-center.vue?vue&type=template&id=dba48024"
import script from "./fund-center.vue?vue&type=script&lang=js"
export * from "./fund-center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports